import { accountConstants } from '../constants'

const initialState = {
  loading: false,
  error: null,
  list: null,
  count: 0,
  init: false,
  updating: false
}

export default function account(state = initialState, action) {
  switch (action.type) {
    case accountConstants.ACCOUNT_LOAD:
      return {
        ...state,
        loading: true,
        list: null,
        init: true
      }
    case accountConstants.ACCOUNT_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload.list.sort((a, b) =>
          a.sender.localeCompare(b.name)
        ),
        count: action.payload.count
      }
    case accountConstants.ACCOUNT_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case accountConstants.ACCOUNT_SAVE:
    case accountConstants.ACCOUNT_DELETE:
      return {
        ...state,
        updating: true
      }
    case accountConstants.ACCOUNT_SAVE_SUCCESS:
      const list = (
        state.list.find((x) => x._id === action.payload._id)
          ? state.list.map((x) => {
              return x._id === action.payload._id ? action.payload : x
            })
          : [...state.list, action.payload]
      ).sort((a, b) => a.sender.localeCompare(b.name))
      return {
        ...state,
        updating: false,
        list,
        count: list.count
      }
    case accountConstants.ACCOUNT_SAVE_FAILURE:
    case accountConstants.ACCOUNT_DELETE_FAILURE:
      return {
        ...state,
        updating: false,
        error: action.payload
      }
    case accountConstants.ACCOUNT_DELETE_SUCCESS:
      return {
        ...state,
        updating: false,
        list: state.list.filter((x) => x._id !== action.payload),
        count: state.count - 1
      }
    case accountConstants.ACCOUNT_RESET:
      return {
        ...initialState
      }
    default:
      return state
  }
}
